import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { SMTP_COLOR } from "../../../../constants/socialColors.constant";
import { IconProps } from "../Facebook/FacebookIcon";

export const SmtpIcon = (props: IconProps) => {
  const { active, className, size = "1x", color } = props;
  return (
    <FontAwesomeIcon
      style={{
        color: color || (active ? SMTP_COLOR : "gray"),
      }}
      icon={["far", "envelope"]}
      className={className}
      size={size}
    />
  );
};
